import React, { FC } from 'react';
import styles from './nav_header.module.scss';

export const NavHeader: FC = ({ children }) => (
  <nav className={styles.container}>{children}</nav>
);
